/* @flow */
// $FlowIgnore
import d3 from 'd3';
import React, { useRef } from 'react';
// $FlowIgnore
import ReactFauxDOM from 'react-faux-dom';

import Row from 'components/UIKit/Flex/Row';

type Props = {
  withDataAnimate: number,
  withData: number,
  withoutData: number,
  colour: string,
  abbr: string,
  type: string,
  icon: () => {},
  isFetching: boolean
}

type renderSVGProps = {
  withDataAnimate: number,
  withData: number,
  withoutData: number,
  colour: string,
  type: string,
  icon: () => {},
  isFetching: boolean
}

type Slice = {
  key: string,
  value: number
}

type Slices = [Slice]

const Donut = (props : Props) => {
  const renderSVG = ({
    withDataAnimate, withData, withoutData, isFetching, colour, type, icon, elRef,
  }: renderSVGProps) => {
    const totalCount = withData + withoutData;

    const node: any = ReactFauxDOM.createElement('svg');
    // Fill in graph when counts are 0
    const data: Slices = [
      { key: 'with', value: withDataAnimate },
      // if withoutData just use that
      // if withoutData === 0 check withData
      // if withData use that - but have it shrink as withDataAnimate loads so the graph fills properly
      // otherwise they are both 0 so set denominator to 1 to not break graph
      {
        key: 'without',
        value: withoutData || (withData ? (withData - withDataAnimate) : 1),
      },
    ];

    const diameter: number = elRef?.current?.offsetWidth || 0;

    const radius: number = diameter / 2;

    const getColor: (_: string) => string = d3.scale.ordinal().range([colour, '#fff']);

    const arc = d3.svg.arc()
      .outerRadius(radius - 18)
      .innerRadius(radius - 36);

    const pie: (_:Slices) => Slices = d3.layout.pie()
      .sort(null)
      .value((d: Slice) => d.value);

    const svg = d3.select(node).attr({
      width: diameter,
      height: diameter,
    }).append('g').attr({
      transform: `translate(${radius},${radius})`,
    });

    if (!isFetching) {
      svg.append('text')
        .attr('x', 0)
        .attr('y', 0 - radius / 3)
        .style('text-anchor', 'middle')
        .attr('font-weight', 'bold')
        .style('font-size', '1rem')
        .text(`${withData}`);

      svg.append('text')
        .attr('x', 0)
        .attr('y', -radius / 10)
        .style('text-anchor', 'middle')
        .style('font-size', '0.8rem')
        .text(
          // 0 items instead of 0% of 0 items
          `${totalCount
            ? `${(withData / (totalCount || 1) * 100).toFixed(0)}% of`
            : ''}
            ${totalCount} ${type}`,
        );

      svg.append('line')
        .attr('x1', -30)
        .attr('y1', 5)
        .attr('x2', 30)
        .attr('y2', 5)
        .attr('stroke-width', 2)
        .attr('stroke', '#ccc');

      svg.append('g')
        .attr({
          transform: 'translate(-12,15)',
        })
        .html(icon({ style: { fontSize: '1.8rem', color: `${colour}` } }));
    }

    const g = svg.selectAll('.arc')
      .data(pie(data))
      .enter().append('g')
      .attr('class', 'arc');

    g.append('path')
      .attr('d', arc)
      .attr('stroke', colour)
      .attr('stroke-width', 2)
      .style('fill', (d: {data: Slice}): string => getColor(d.data.key));

    return node.toReact();
  }

    const {
      withData, withoutData, colour, type, icon, isFetching
    } = props;
    const elRef = useRef();

    return (
      <div ref={elRef}>
        <Row>
          {renderSVG({
            withDataAnimate: withData,
            withData: withData || 0,
            withoutData: withoutData || 0,
            colour,
            isFetching,
            type,
            icon,
            elRef,
           })}
        </Row>
      </div>
    );
}

export default Donut;